export default __webpack_public_path__ + "static/media/google_pay.6941f834.png";